import { useId } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NATIVE_WIDTH = 48;
const NATIVE_HEIGHT = 35;
export const GradientCapsIcon = ({
  size = 20
}) => {
  const id = useId();
  const paint0 = `${id}-paint0`;
  const clip0 = `${id}-clip0`;
  const mask0 = `${id}-mask0`;
  const mask1 = `${id}-mask1`;
  const height = size * NATIVE_HEIGHT / NATIVE_WIDTH;
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: height,
    viewBox: "0 0 48 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: `url(#${clip0})`,
      children: [/*#__PURE__*/_jsx("mask", {
        id: mask0,
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "-1",
        y: "-8",
        width: "49",
        height: "49",
        children: /*#__PURE__*/_jsx("path", {
          d: "M47.5586 -7.26465H-0.441406V40.7354H47.5586V-7.26465Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: `url(#${mask0})`,
        children: [/*#__PURE__*/_jsxs("mask", {
          id: mask1,
          style: {
            maskType: 'alpha'
          },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "48",
          height: "35",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M44.5606 30.2732V12.6935C44.5606 10.3671 43.014 8.34551 40.7638 7.73651L25.3447 3.61297L25.3361 3.61004C24.4769 3.37585 23.5583 3.37578 22.6993 3.61004L22.6935 3.61297L3.79257 8.6828L3.78378 8.68573C3.62697 8.72684 3.5585 8.79337 3.52012 8.84687C3.47212 8.91397 3.4337 9.01679 3.4337 9.1413C3.43384 9.26574 3.47272 9.3711 3.52305 9.44159C3.56404 9.4988 3.63563 9.5674 3.79403 9.61004L22.6935 14.6799L22.7008 14.6813C23.5599 14.9157 24.4769 14.9156 25.3361 14.6813L25.3447 14.6799L39.0235 11.0192C39.9399 10.7741 40.8819 11.3187 41.1271 12.235C41.3722 13.1512 40.8288 14.0932 39.9127 14.3386L26.2385 17.9948C24.7879 18.3903 23.2475 18.3918 21.797 17.9963L2.90342 12.9279C-0.944543 11.8929 -0.993942 6.38608 2.9122 5.362L21.8028 0.295117C23.2517 -0.0987715 24.7913 -0.0984598 26.2399 0.29658L41.6515 4.42012H41.6559C45.4039 5.43208 47.9957 8.81123 47.9957 12.6935V30.2732C47.9957 31.2217 47.226 31.9914 46.2775 31.9914C45.3293 31.9909 44.5606 31.2215 44.5606 30.2732Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M8.54688 26.959V20.5988C8.54688 19.6501 9.31511 18.8818 10.2637 18.8818C11.2122 18.8818 11.9805 19.6501 11.9805 20.5988V26.959C11.9806 27.5866 12.3012 28.1362 12.7539 28.4209L12.9561 28.5265L12.9634 28.5294C20.3324 31.6753 27.6301 31.6753 34.999 28.5294L35.0065 28.5265C35.5628 28.2918 35.9804 27.6766 35.9804 26.959V20.5988C35.9804 19.6501 36.7501 18.8818 37.6988 18.8818C38.6473 18.8818 39.4155 19.6501 39.4155 20.5988V26.959C39.4155 28.9412 38.2743 30.8768 36.3409 31.6921C28.1151 35.2016 19.8473 35.2002 11.6216 31.6904C9.6882 30.8751 8.54702 28.9412 8.54688 26.959Z",
            fill: "white"
          })]
        }), /*#__PURE__*/_jsx("g", {
          mask: `url(#${mask1})`,
          children: /*#__PURE__*/_jsx("path", {
            d: "M47.5586 -7.26465H-0.441406V40.7354H47.5586V-7.26465Z",
            fill: `url(#${paint0})`
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: paint0,
        x1: "0.409167",
        y1: "-6.60225",
        x2: "46.8492",
        y2: "39.9481",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FB31A7"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.35",
          stopColor: "#FF4800"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FBDDD2"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: clip0,
        children: /*#__PURE__*/_jsx("rect", {
          width: "48",
          height: "48",
          fill: "white",
          transform: "translate(-0.441406 -7.26465)"
        })
      })]
    })]
  });
};